import React, { useEffect, useState } from "react";
import PropertiesFilterBar from "../components/properties/PropertiesFilterBar";
import "./Properties.css";
import PropertiesHero from "../components/properties/PropertiesHero";
import PropertiesResults from "../components/properties/PropertiesResults";
import httpAction from "../utils/httpAction";
import apis from "../utils/apis";
import useGeneral from "../hooks/useGeneral";
import { useSearchParams } from "react-router-dom";

export default function Properties() {
  const { loading, setLoading, goToTop } = useGeneral();
  const [properties, setProperties] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  // goToTop();

  // ✅ Always create fresh params (otherwise old keys stay)
  const buildQS = (filters) => {
    const params = new URLSearchParams();

    if (filters?.q?.trim()) params.set("q", filters.q.trim());
    if (filters?.location && filters.location !== "All")
      params.set("location", filters.location);

    if (filters?.type && filters.type !== "All")
      params.set("type", filters.type);
    if (filters?.beds && filters.beds !== "Any")
      params.set("beds", filters.beds);

    if (filters?.minPrice?.trim())
      params.set("minPrice", filters.minPrice.trim());
    if (filters?.maxPrice?.trim())
      params.set("maxPrice", filters.maxPrice.trim());

    if (filters?.sort) params.set("sort", filters.sort);

    return params.toString();
  };

  const getProperties = async (filters) => {
    const qs = buildQS(filters);

    const data = {
      url: `${apis().getListingList}${qs ? `?${qs}` : ""}`,
    };

    setLoading(true);
    const result = await httpAction(data);
    setLoading(false);

    if (result?.status) setProperties(result.list);
  };



  useEffect(() => {
    const filters = {
      q: searchParams.get("q")  || searchParams.get('location') || "",
      location:  "All",
      type: searchParams.get("type") || "All",
      minPrice: searchParams.get("minPrice") || "",
      maxPrice: searchParams.get("maxPrice") || "",
      beds: searchParams.get("beds") || "Any",
      sort: searchParams.get("sort") || "Newest",
    };

   

    getProperties(filters);
  }, [searchParams]);

  return (
    <div className="propsPage">
      <PropertiesHero />
      <PropertiesFilterBar currentFilters={{
        q: searchParams.get("q") || searchParams.get('location') || "",
        location: searchParams.get("location") || "All",
        type: searchParams.get("type") || "All",
        minPrice: searchParams.get("minPrice") || "",
        maxPrice: searchParams.get("maxPrice") || "",
        beds: searchParams.get("beds") || "Any",
        sort: searchParams.get("sort") || "Newest",
      }} onSearch={(filters) => {
        const qs = buildQS(filters);
        setSearchParams(qs ? new URLSearchParams(qs) : new URLSearchParams());
      }} />
      <PropertiesResults onLoading={loading} result={properties} />
    </div>
  );
}
